import type { Quill } from "@vueup/vue-quill";

export type TrimmedSelectionRange = {
  trimmedStart: number;
  trimmedEnd: number;
  text: string;
};

/**
 * Given a Quill selection range (start, end), returns the same range with
 * leading and trailing spaces trimmed, plus the trimmed text.
 */
export const useTrimmedSelectionRange = () => {
  return (
    start: number,
    end: number,
    quill: Quill
  ): TrimmedSelectionRange | null => {
    const length = end - start;
    if (length <= 0) return null;

    const selectedText = quill.getText(start, length);
    const leadingSpaces =
      selectedText.length - selectedText.trimStart().length;
    const trailingSpaces =
      selectedText.length - selectedText.trimEnd().length;
    const trimmedLength = length - leadingSpaces - trailingSpaces;

    const trimmedStart = start + leadingSpaces;
    const trimmedEnd = trimmedStart + trimmedLength;

    return {
      trimmedStart,
      trimmedEnd,
      text: selectedText.slice(leadingSpaces, selectedText.length - trailingSpaces),
    };
  };
};
